























import { Component, Vue } from "vue-property-decorator";
import QRCode from "qrcode";

@Component
export default class ShowPass extends Vue {
  lastCode = localStorage.getItem("lastQRCode");
  mounted() {
    if (this.lastCode) {
      QRCode.toCanvas(this.$refs.qrcode, this.lastCode, function(error) {
        if (error) console.error(error);
        console.log("success!");
      });
    }
  }
  get localCodeLink(): string {
    console.log("last: " + this.lastCode);
    console.log("host:" + window.location.origin);
    return this.lastCode?.substring(window.location.origin.length) ?? "";
  }
}
